<template>
  <div v-loading="loading" class="content-wrapper">
    <div class="content-title">购物车</div>
    <PurchaseSteps :cur-step="0" />
    <CartView :cart-list="cartList" :cooler-gift-qty="coolerGiftQty" />
  </div>
</template>

<script>
import PurchaseSteps from '@/components/purchase-steps'
import CartView from './components/cart-view'
export default {
  name: 'CartList',
  components: {
    PurchaseSteps,
    CartView
  },
  data() {
    return {
      cartList: [],
      loading: false,
      coolerGiftQty: null
    }
  },
  computed: {
    
  },
  mounted() {
    this.getCartList()
  },
  methods: {
    getCartList() {
      this.loading = true
      this.$store.dispatch('FetchCartList').then(response => {
        this.loading = false
        const cartList = response.data.resultData.cartList
        cartList.map(item => {
          item.stepQty = item.moqmultiple ? item.moqmultiple : 1
          item.minQty = item.moqmultiple ? item.moqmultiple : 1
          item.maxQty = item.isPreOrder === 1 ? Infinity : (parseInt(item.availableQty/item.stepQty) * item.stepQty)
        })
        this.cartList = cartList

        const hasCoolerGift = this.cartList.some(item => {
          return item.activityFlag
        })
        if (hasCoolerGift) {
          this.getCoolerGiftQty()
        }
      }).catch(() => {
        this.loading = false
      })
    },

    // 获取冰柜赠品数量
    async getCoolerGiftQty() {
      const { data } = await this.$store.dispatch('getCoolerGiftQty')
      if (data.resultCode === '0') {
        if (data.resultData) {
          this.coolerGiftQty = data.resultData.giftQuotaQty || 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
